import { Box, Button, Typography, Avatar, Divider } from "@mui/material";
import React from "react";

const AppointmentCard = ({
  appointmentId = "#1234567",
  productTitle = "Jordan 1 Retro High Tie Dye",
  productPrice = "$80.00",
  productImage,
  appointmentDate = "Aug 23, 2023",
  appointmentTime = "02:30 PM",
  user = {
    name: "Full Name",
    location: "City, State",
    avatar: "",
  },
  status = "upcoming", // or "past"
  onAccept,
  onDecline,
  onReschedule,
}) => {
  return (
    <Box
      sx={{
        borderRadius: "16px",
        border: "1px solid #eee",
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        p: 2,
        mb: 2,
        maxWidth: 700,
        backgroundColor: "#f9f9f9",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          p: 1,
          backgroundColor: "#fff",
          borderRadius: 2,
        }}
      >
        <Avatar
          src={productImage}
          variant="rounded"
          sx={{ width: 60, height: 60 }}
        />
        <Box>
          <Typography variant="caption" color="text.secondary">
            {appointmentId}
          </Typography>
          <Typography fontWeight="bold">{productTitle}</Typography>
          <Typography fontWeight="medium" color="text.secondary">
            {productPrice}
          </Typography>
        </Box>
      </Box>

      <Divider sx={{ my: 1 }} />

      {/* Appointment Details */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          backgroundColor: "#fff",
          borderRadius: 2,
          p: 1,
          gap: 2,
        }}
      >
        {/* Date/Time + Reschedule */}
        <Box
          sx={{
            backgroundColor: "#f9f9f9",
            borderRadius: 2,
            p: 2,
            flexGrow: 1,
            minWidth: 200,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              flexWrap: "wrap",
              gap: 5,
            }}
          >
            <Box sx={{ mb: 1 }}>
              <Typography fontSize="12px" color="text.secondary">
                Date
              </Typography>
              <Typography>{appointmentDate}</Typography>
            </Box>
            <Box>
              <Typography fontSize="12px" color="text.secondary">
                Time
              </Typography>
              <Typography>{appointmentTime}</Typography>
            </Box>
          </Box>

          <Box
            sx={{
              mt: 2,
              textAlign: "center",
              cursor: "pointer",
              color: "#9c27b0",
              fontWeight: 500,
              fontSize: "14px",
              background: "#fff",
              p: 2,
              borderRadius: 2,
            }}
            onClick={onReschedule}
          >
            Reschedule Appointment
          </Box>
        </Box>

        {/* User Info */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            justifyContent: "center",
            gap: 1,
            minWidth: 200,
          }}
        >
          <Avatar src={user.avatar} />
          <Box>
            <Typography>{user.name}</Typography>
            <Typography variant="body2" color="text.secondary">
              {user.location}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Footer Actions */}
      {status === "PENDING" && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: 2,
            gap: 2,
          }}
        >
          <Button
            variant="outlined"
            color="error"
            onClick={onDecline}
            sx={{ borderRadius: "30px", px: 4, textTransform: "none" }}
          >
            Decline
          </Button>
          <Button
            variant="contained"
            onClick={onAccept}
            sx={{
              backgroundColor: "#000",
              borderRadius: "30px",
              px: 4,
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#222",
              },
            }}
          >
            Accept
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default AppointmentCard;
